(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('PasswordV2Controller', PasswordV2Controller);

    PasswordV2Controller.$inject = ['Auth', 'Principal', '$rootScope'];

    function PasswordV2Controller(Auth, Principal, $rootScope) {
        var vm = this;

        vm.changePassword = changePassword;
        vm.doNotMatch = null;
        vm.error = null;
        vm.success = null;

        vm.okModal = okModal;
        vm.closeModal = closeModal;

        Principal.identity().then(function (account) {
            vm.account = account;
        });

        function changePassword() {
            if (vm.password !== vm.confirmPassword) {
                vm.error = null;
                vm.success = null;
                vm.doNotMatch = 'ERROR';
            } else {
                vm.doNotMatch = null;
                Auth.changePassword(vm.password).then(function () {
                    vm.error = null;
                    vm.success = 'OK';
                    $rootScope.modalInstance.dismiss('cancel');
                }).catch(function () {
                    vm.success = null;
                    vm.error = 'ERROR';
                });
            }
        }

        function closeModal() {
            if ($rootScope.modalInstance) {
                $rootScope.modalInstance.dismiss('cancel');
            }

        }

        function okModal() {
            changePassword();
        }

    }
})();
